import styled from 'styled-components';

export const MessageContainer = styled.div`
  position: absolute;
  bottom: 12px;
  left: 0;
  right: 0;
  margin: 0 12px 12px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgb(185, 205, 216);
  border-radius: 10px;
  padding: 4px 15px;
  min-height: 35px;
  position: sticky;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s ease;

  ${props => props.$hasFile && `
    background-color: #1E1E1E;
    &:hover, &:focus-within {
      background-color: #1E1E1E;
    }
  `}
`;

export const IconWrapper = styled.div`
  width: 20px;
  height: 30px;
  background-color: transparent;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
  opacity: ${(props) => (props.disabled ? 0.8 : 1)};

  img, svg {
    width: 20px;
    height: 20px;
    filter: invert(1);  // Simplified filter
    fill: white;        // Add fill for SVGs
    color: white;       // Add color for SVGs
  }

  svg path {
    fill: white;        // Ensure SVG paths are white
  }
`;

export const Input = styled.input`
  height: 100%;
  border: none;
  background-color: transparent !important;
  font-family: 'Roboto', sans-serif;
  font-size: 15px;
  font-weight: 300;
  color: rgba(210, 210, 210, 0.9);
  margin-left: 0.5rem;
  flex-grow: 1;
  opacity: ${props => props.disabled ? 0.8 : 1};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  transition: all 0.2s ease;

  &:focus, &:hover, &:active {
    outline: none;
    background-color: transparent !important;
  }

  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
    font-size: 14px;
  }
`;

// Left and right sections of the message input
export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FilePreview = styled.div`
  display: inline-flex;
  align-items: center;
  background-color: transparent;
  color: white;
  padding: 2px 8px;
  font-size: 14px;
`;

export const RemoveFileButton = styled.button`
  background: none;
  border: none;
  color: white;
  margin-left: 8px;
  cursor: pointer;
  padding: 2px;
`;

// Recording UI components
export const RecordingIndicator = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #ff4136;
  top: 0;
  right: 0;
  animation: pulse 1.5s infinite;

  @keyframes pulse {
    0% { transform: scale(0.8); opacity: 1; }
    50% { transform: scale(1.2); opacity: 0.8; }
    100% { transform: scale(0.8); opacity: 1; }
  }
`;

export const RecordingTimer = styled.div`
  position: absolute;
  top: -20px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  white-space: nowrap;
`;

export const TranscriptionLoadingIndicator = styled.div`
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
  background-color: rgba(0, 0, 0, 0.7);
  padding: 2px 6px;
  border-radius: 4px;
`;

export const Message = ({ hasFile, children, ...props }) => (
  <MessageContainer $hasFile={hasFile} {...props}>
    {children}
  </MessageContainer>
);

export default {
  MessageContainer,
  IconWrapper,
  Input,
  LeftSection,
  RightSection,
  FilePreview,
  RemoveFileButton,
  RecordingIndicator,
  RecordingTimer,
  TranscriptionLoadingIndicator,
  Message
}; 